'use client';
import React from 'react';
import 'photoswipe/dist/photoswipe.css';
import Image from 'next/image';
import { Gallery, Item } from 'react-photoswipe-gallery';
import style from './style.module.scss'

interface NewsPosterProps {
  poster: string;
}
export const NewsPoster = ({ poster }: NewsPosterProps) => {
  return (
    <div className={style.wrapper}>
    <Gallery>
      <Item  original={poster} thumbnail={poster}  width="1024" height="768">
        {({ ref, open }) => (
          <Image objectFit='cover' className={style.poster}  ref={ref} onClick={open} src={poster} width={506} height={332} alt="poster" />
        )}
      </Item>
    </Gallery>
    </div>
  );
};
